import React, { useMemo } from "react";
import { Link } from "react-router-dom";

import { addCommas } from "@persian-tools/persian-tools";

import CartItemSection, { CartItemSectionProps } from "./CartItemSection";
import Image from "../Image";
import ColorSchema from "../../../assets/kits/colors";

interface ProductCardProps extends CartItemSectionProps {
  imagePath: string;
  title: string;
  price: number;
  discount?: number;
  width: number;
  link: string;
}

const ProductCard: React.FC<ProductCardProps> = ({
  imagePath,
  title,
  price,
  discount,
  width,
  link,
  ...cartProps
}) => {
  const hasDiscount = useMemo(
    () => Boolean(discount && +discount !== 0),
    [discount]
  );

  return (
    <div className="product-card" style={{ width }}>
      <Link to={link} style={{ textDecoration: "none", color: "#000000" }}>
        <div
          className="pc-main"
          style={{ height: width, overflow: "hidden", borderRadius: 6 }}
        >
          <Image
            container={{ className: "pc-image" }}
            src={imagePath}
            alt={title}
          />
          <CartItemSection {...cartProps} />
          {hasDiscount && (
            <div className="pc-discount pd-x-4 desc-r">
              {Math.ceil((discount! / price) * 100)}٪
            </div>
          )}
        </div>
        <div className="pc-description mr-t-6">
          <p className="pc-title desc-r mr-b-12">{title}</p>
          <div className="d-flex justify-content-end">
            <p
              className="desc-l"
              style={{
                textDecoration: hasDiscount ? "line-through" : "none",
                color: ColorSchema.foreground_background_me,
              }}
            >
              {addCommas(price)} تومان
            </p>
            {hasDiscount && (
              <p className="desc-l mr-r-4">
                {addCommas(price - discount!)}
                تومان
              </p>
            )}
          </div>
        </div>
      </Link>
    </div>
  );
};

export default ProductCard;
